import { render } from "./MainLayout.vue?vue&type=template&id=f56c7256&ts=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/uwemudoh/Sites/flywave/qatgifts/qatGiftsBackoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__